import { types } from "../types/types";

export const msgError = (msg) => ({
    type: types.msgSetError,
    payload:{
        msg
    }
}) 

export const removeError = () => ({
    type: types.msgRemoveError
}) 